
import React, { Fragment } from "react";
import { Card } from 'reactstrap';
import moment from 'moment';
const RecentOrder = ({ data }) => {
    return (
        <div className="row">
            <div className="col-md-12 mb-4">
                <Card style={{ height: '684px' }} className="order-overflow">
                    <div style={{ padding: '10px' }}>
                        <div className="float-left float-none-xs">
                            <div className="d-inline-block">
                                <h5 className="d-inline">
                                    Recent Purchases
                                </h5>
                            </div>
                        </div>
                    </div>
                    <div className="chart card-body pt-0 ">
                        {data.map((m) => {
                            return (
                                <Fragment>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="react-photo-gallery--gallery">
                                                <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
                                                    <img
                                                        alt="Thumbnail"
                                                        src={
                                                            m.image !== ''
                                                                ? m.image
                                                                : 'https://via.placeholder.com/250x150'
                                                        }
                                                        className="ml-2 mb-3 bmb-img  voucher-list-thumbnail responsive border-0"
                                                    />
                                                    {m.redeem ? <span className="badge badge-pill badge-primary text-right
            position-absolute badge badge-top-recent">Redeemed</span> : <span className="badge badge-pill bg-secondry text-right
            position-absolute badge badge-top-recent">Not Redeemed</span>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="recent col-md-9 mr-2">
                                            <div className="pl-3 pr-2">
                                                <a href="/app/pages/orders">
                                                    <p className="font-weight-medium mb-1">{m.voucherName}</p>
                                                    <p className="order-overflow my-3  text-small">{m.voucherInfo}</p>
                                                    <p className="my-4 text-small">{moment(m.date).format("DD-MM-YYYY")}</p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            );
                        })}
                    </div>
                </Card >
            </div>
        </div>
    );
};
export default RecentOrder;